import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import '../../common/theme/UserFlowPage.scss';
import { Link, Button, Box, IconButton } from '@mui/material';

const ForgotUsernameModal = ({ toggleModal, toggleChatbot }) => {
    const openChatBot = () => {
        toggleModal();
        toggleChatbot();
    }
    
    return (
        <Box id="forgot-username-modal" className="forgot-username-modal-container">
            <Box className="forgot-username-modal">
            <Box id="close-modal" className="close-modal">
                <IconButton aria-label='close' onClick={toggleModal} disableRipple className='close-icon'>
                <CloseIcon />
            </IconButton></Box>
            <Box className="modal-title">Forgot your username?</Box>
            <Box className="modal-subtitle">Contact system support</Box>
            <Box className="modal-details">
                <Box>We're available M-F, 8 am-5 pm ET. Or leave a voicemail after business hours.</Box>
                <Box>Weekends and holidays 8 am-9 pm ET. Please leave a voicemail and a member of system support will return your call as soon as possible.</Box>
            </Box>
            <Box className="modal-links">
                <Link className="modal-call-us" href="tel:+1 (866) 527-9583">
                    <img className="desktop-modal-phone-icon" src={require('../../common/assets/img/call-us-gray.png')} alt="Call us" />                            
                    <Box className="modal-link">1-866-527-9583</Box>
                </Link>
                <Link className="modal-mail-us" href="mailto:systemsupport@amig.com">
                    <img className="modal-mail-icon" src={require('../../common/assets/img/email-us-purple.png')} alt="Email us" />
                    <Box className="modal-link">systemsupport@amig.com</Box>
                </Link>
            </Box>
            <Box className="modal-buttons">
                <Button id="dismiss-modal" className="modal-cancel" onClick={toggleModal} disableRipple>
                    Cancel
                </Button>
                <Link className="modal-live-chat" onClick={openChatBot} target="_blank" rel='noreferrer'>
                    <Button className="live-chat-button" disableRipple>
                        <img src={require('../../common/assets/img/people-icon.png')} alt="Chat" />
                        Chat
                    </Button>
                </Link>
            </Box>
        </Box>
        </Box>
    );
    };

export default ForgotUsernameModal;
